<template>
  <v-dialog v-model="show" max-width="500px" persistent>
    <v-card>
      <v-card-title>ルビ振り</v-card-title>

      <v-card-text class="px-5 mt-4">
        <p class="mb-4">Wordファイル(.docx)をアップロードすると、漢字にルビを振ったファイルをダウンロードできます。</p>

        <v-alert type="warning" outlined class="mb-4">
          ダウンロードしたルビ版データは完全なデータではないため、ダウンロード後にルビが正しく振られているか、ご確認をお願いいたします。
        </v-alert>

        <v-alert type="info" outlined class="mb-4">
          Web版のWordにはルビ振り機能がないため、ルビ振り後のデータでは崩れた体裁で表示されます。正しい体裁はダウンロードしたファイルをWordアプリで開いてご確認ください。
        </v-alert>

        <v-file-input
          v-if="!processing"
          v-model="file"
          accept=".docx"
          label="Wordファイルを選択"
          prepend-icon="mdi-file-word"
          outlined
          :disabled="processing"
        />

        <div v-if="processing" class="text-center py-8">
          <v-progress-circular indeterminate color="primary" size="64" />
          <p class="mt-4">ルビを振っています...</p>
        </div>

        <v-alert v-if="errorMessage" type="error" class="mt-4" dismissible @input="errorMessage = null">
          {{ errorMessage }}
        </v-alert>
      </v-card-text>

      <v-card-actions class="card-action">
        <v-spacer />
        <v-btn color="gray" class="dialog-Button" @click="close" :disabled="processing">閉じる</v-btn>
        <v-btn color="primary" class="dialog-Button" @click="upload" :disabled="!file || processing">
          ルビを振る
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    show: false,
    file: null,
    processing: false,
    errorMessage: null,
  }),

  methods: {
    open() {
      this.show = true
      this.file = null
      this.errorMessage = null
    },

    close() {
      this.show = false
      this.file = null
      this.processing = false
      this.errorMessage = null
    },

    async upload() {
      if (!this.file) return

      this.processing = true
      this.errorMessage = null

      const formData = new FormData()
      formData.append('file', this.file)

      try {
        const response = await this.$axios.post(
          '/api/v1/teacher/ruby/process_word',
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            responseType: 'blob',
            timeout: 300000, // 5分
          }
        )

        // ファイル名を取得
        const filename = this.getFilenameFromContentDisposition(response.headers['content-disposition'])
          || this.file.name.replace('.docx', '_rubi.docx')

        // ダウンロード
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.close()
      } catch (error) {
        this.processing = false
        if (error.response && error.response.data) {
          // Blobからエラーメッセージを取得
          try {
            const text = await error.response.data.text()
            const json = JSON.parse(text)
            this.errorMessage = json.error || 'エラーが発生しました'
          } catch {
            this.errorMessage = 'エラーが発生しました'
          }
        } else {
          this.errorMessage = 'ネットワークエラーが発生しました'
        }
      }
    },

    getFilenameFromContentDisposition(contentDisposition) {
      if (!contentDisposition) return null

      // filename*=UTF-8''encoded-filename 形式を優先的に使用
      const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/i)
      if (filenameStarMatch) {
        return decodeURIComponent(filenameStarMatch[1])
      }

      // filename="filename" 形式をフォールバック
      const filenameMatch = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/i)
      if (filenameMatch) {
        return filenameMatch[1]
      }

      return null
    }
  }
}
</script>

<style lang="stylus" scoped>
.card-action
  justify-content flex-end

.dialog-Button
  font-weight normal
  min-width 100px
</style>
